import { Server } from "http";

// Local path
// export const BASE_URL = "http://192.168.1.128:9092/mrroom";
// export const BASE_URL = "http://localhost:9092/mrroom";

// edwin local path
// export const BASE_URL = "http://localhost:9092/mrroom";
// export const MS_REDIRECT_URL = "http://localhost:4200/";

//    New Server
export const BASE_URL = "https://zelo.zelomeetings.com/mrroom";
export const MS_REDIRECT_URL = "https://zelomeetings.com/admin/";

// export const MS_REDIRECT_URL = "http://localhost/admin/";
// export const MS_REDIRECT_URL = "http://localhost:4210/";


// zelomeetings.com:9092 path

// export const BASE_URL = "https://zelomeetings.com:9092/mrroom";

//Laia path 
export const LAIA_BASE_URL = "https://myteamplanner.com:9094/mrroom";
// export const LAIA_BASE_URL = "http://192.168.1.128:9093/mrroom";



//live
// export const BASE_URL = "https://zelo.zelomeetings.com/mrroom";
// export const MS_REDIRECT_URL = "https://zelomeetings.com/admin/";

//dev
// export const BASE_URL = "https://zelomeetings.com:9094/mrroom";

// export const MS_REDIRECT_URL = "https://zelomeetings.com/dev/";


// zelomeetings.com:9093 dev path

// export const BASE_URL = "https://zelomeetings.com:9093/mrroom";
// export const MS_REDIRECT_URL = "https://zelomeetings.com/dev/";


// zelo.zelomeetings.com:9093 path

// export const BASE_URL = "https://zelo.zelomeetings.com/mrroom";

// export const MS_REDIRECT_URL = "https://zelomeetings.com/admin/";


export const MS_TENANT_ID = "";

export const MS_APPLICATION_ID = "f6e906f5-82ba-46f2-b3f0-73c4ad692718";

export const MS_CLIENT_SECRET = "Vik8Q~rAl5CIH0TTKBMkNjCHIwDtkueIYi4Jcduh";


export const GOOGLE_API_KEY = "f6e906f5-82ba-46f2-b3f0-73c4ad692718";

export const GOOGLE_CLIENT_ID = "245989026495-ecr138v72ln34l4tlhnoq1ied444vap9.apps.googleusercontent.com";

export const GOOGLE_SCOPES = "profile,email,https://www.googleapis.com/auth/calendar,https://www.googleapis.com/auth/userinfo.profile,https://www.googleapis.com/auth/userinfo.email";

export const GOOGLE_DISCOVERY_DOCS = "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest";